import { Component, OnInit, ViewChild } from '@angular/core';
import { ManageUsersPSRGrpService } from '@data/managePSRGroupUsers/manage-psr-grp-users.service';
import { ManageUsersService } from '@data/manageUsers/manage-users.service';
import { User } from '@data/user/user';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { ConfirmationPopupOption, ConfirmationResponse } from '@shared/common-components/confirmation-popup/confirmation-popup.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { PermissionService } from '@shared/services/permission.service'; // Generated by Copilot
import { DxDataGridComponent } from 'devextreme-angular';
import { Column} from 'devextreme/ui/data_grid';
import { custom } from 'devextreme/ui/dialog';


interface ManageGroupPSRUsers{
  userId:number;
  psrGroupId:number;
  psrGroupName: string,
  firstName:string;
  lastName:string;
  speId:string;
  email:string;
  mpgpsrUserRefId:number;
}

interface PSRGroup{
  psrGroupId: number;
  psrGroupName: string;
  psrGroupDesc: string;
  createdBy: string;
  createdDate: Date;
  modifiedBy: string;
  modifiedDate: Date;
  financeFlag: boolean;
  creativeExecutiveFlag: boolean;
  userSet: any;
}

@Component({
    selector: 'app-psr-group-manage-user',
    templateUrl: './psr-group-manage-user.component.html',
    styleUrls: ['./psr-group-manage-user.component.less'],
    standalone: false
})
export class PsrpsrGroupManageUserComponent implements OnInit {
  showSelect:boolean = false;
  loadingData=false;
  locked:boolean = false;
  manageGrpPsrUsersData: ManageGroupPSRUsers[] = [];
  psrGroups: PSRGroup[] = [];
  existingUserList: User[] = [];
  saveUpdateGrpData: any[] = [];
  groupNameData: any;
  showLoadPanel: boolean = false;
  editRow: any;
  existingUsers: any;
  emailvalidate: any[];
  getSpeID: any[];
  confirmationPopupOption:ConfirmationPopupOption;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#publishHistoryGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };
  allowEditing:boolean = true;
  isrowEdit:boolean = false;

@ViewChild('dataGridPSRgrpUser', { static: false }) dataGridPSRView!: DxDataGridComponent;
  setFirstName: any;
  selectedGroup: any;
  autoForm: boolean = false;
  disManageUsersGrp: boolean = false;
  prevData: any;
  prevSpid: any;
  reSetted: boolean = false;
  customIDMsg: string = "SPE ID is associated with an existing user. Please use the 'Add Existing User' field.";

  constructor(private grpUsersService: ManageUsersPSRGrpService, private commonService: CommonDataService,
    private manageUserService: ManageUsersService, private permissionService: PermissionService) {
    this.fetchPSRGroups();
    this.getManageUsers();
    this.fetchMPGGrpUser();
    this.selectGroupName = this.selectGroupName.bind(this);
    this.selectExistingUser = this.selectExistingUser.bind(this);
    this.customValidation = this.customValidation.bind(this);
    this.customIDValidation = this.customIDValidation.bind(this);
    this.customGroupValidation = this.customGroupValidation.bind(this);
    this.searchParamValidation = this.searchParamValidation.bind(this);
    // Permission check — use numeric permissionId via PermissionService — Generated by Copilot
    if(this.permissionService.hasReadOnlyAccess('Admin') || this.permissionService.hasReadOnlyAccess('Post-Production Admin')){
			this.disManageUsersGrp=true;
		}
   }

  ngOnInit(): void {
  }

  fetchMPGGrpUser(){
    if(!this.loadingData){
    this.grpUsersService.getPSRGrpUsers().subscribe(
      r => {
        if(r.status=="SUCCESS"){
          if(r.serviceResult){
            this.manageGrpPsrUsersData = r.serviceResult;
          }
        }
      })
    }
  }

  fetchPSRGroups(){
    this.grpUsersService.getPSRGroups().subscribe(
      res => {
        if(res.status=="SUCCESS"){
          if(res.serviceResult){
            this.psrGroups = res.serviceResult;
          }
        }
      });
    }

    getManageUsers(){
      this.manageUserService.getManageUsers().subscribe(
        res => {
          if(res.status=="SUCCESS"){
            if(res.serviceResult){
              this.existingUserList = res.serviceResult;
              this.existingUserList = this.existingUserList.map((data: any) => {
                  data["fullName"] = data.firstName + " " + data.lastName;
                  return data;
              });
        }
      }
        });
      }

searchParamValidation(params: any) {
  if (params.value && params.value.trim() !== '') {
    if (params.data.searchParam != this.prevSpid) {
      this.showLoadPanel = true;
      return this.manageUserService.searchBySpeIdIDM(params.value.toLowerCase()).subscribe(
        res => {
          if (res.status == "SUCCESS") {
            // Check if serviceResult and userDetails exist
            if (res.serviceResult && res.serviceResult.userDetails) {
              // Check if Status is true
              if (res.serviceResult.userDetails.Status === true) {
                this.fillIDMUser(res.serviceResult, params.value);
                this.showLoadPanel = false;
                return true;
              } else {
                // Status is false, show error message from serviceResult
                this.resetFill(params.value);
                this.showLoadPanel = false;
                const errorMessage = res.serviceResult.errorMessage || "Selected user is in inactive state";
                this.customAlert(errorMessage);
                return false;
              }
            } else {
              // serviceResult or userDetails is null/not present
              this.resetFill(params.value);
              this.showLoadPanel = false;
              const errorMessage = res.errorDescription || "User not found";
              this.customAlert(errorMessage);
              return false;
            }
          } else {
            // res.status is not SUCCESS
            this.resetFill(params.value);
            this.showLoadPanel = false;
            const errorMessage = res.errorDescription || "Service unavailable. Please retry or contact app team if issue persists.";
            this.customAlert(errorMessage);
            return false;
          }
        },
        error => {
          // API call error
          this.resetFill(params.value);
          this.showLoadPanel = false;
          this.customAlert("Service unavailable. Please retry or contact app team if issue persists.");
          return false;
        }
      );
    } else {
      return true;
    }
  }
  return true;
}

  customValidation(params: any) {
    let checkExist = this.manageGrpPsrUsersData.filter((item: any) => item.hasOwnProperty("psrGroupId") && item.psrGroupId === this.selectedGroup);
    this.emailvalidate = checkExist.map((a:any) => a.email.toLowerCase());
    let checkMPGUser = this.existingUserList.map((a:any) => a.email.toLowerCase());
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.email.toLowerCase() != params.value.toLowerCase()){
        if(checkMPGUser.includes(params.value.toLowerCase())){
          return false;
        }else {
          return true;
        }
      }else{
        return true
      }
      
    }else if(!this.autoForm && checkMPGUser.includes(params.value.toLowerCase())){
        return false;
      }else{
      return true;
    }
  }

  customIDValidation(params: any){
    let checkExist = this.manageGrpPsrUsersData.filter((item: any) => item.hasOwnProperty("psrGroupId") && item.psrGroupId === this.selectedGroup);
    this.getSpeID = checkExist.map((a:any) => a.speId.toLowerCase());
    let checkMPGUser = this.existingUserList.map((a:any) => a.speId.toLowerCase());
    
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.speId.toLowerCase() != params.value.toLowerCase()){
        if(checkMPGUser.includes(params.value.toLowerCase()) || this.getSpeID.includes(params.value.toLowerCase())){
          this.customIDMsg = "SPE ID is associated with an existing user. Please use the 'Add Existing User' field.";
          return false;
        }else{
          return true;
        }
      }else{
        return true;
      }
    }else if(!this.autoForm && (checkMPGUser.includes(params.value.toLowerCase()) || this.getSpeID.includes(params.value.toLowerCase()))){
      this.customIDMsg = "SPE ID is associated with an existing user. Please use the 'Add Existing User' field.";
      return false;
    } else{
      return true;
    }
  }

  fillIDMUser(data: any, spe: any){
    var idmData=data.userDetails;
    this.dataGridPSRView.instance.cellValue(0, "firstName", idmData["First Name"]);
    this.dataGridPSRView.instance.cellValue(0, "lastName", idmData["Last Name"]);
    this.dataGridPSRView.instance.cellValue(0, "email", idmData["Email"]);
    this.dataGridPSRView.instance.cellValue(0, "speId", idmData["SPE User ID"]);
    this.dataGridPSRView.instance.cellValue(0, "searchParam", spe); // Keeping the search param
    this.dataGridPSRView.instance.cellValue(0, "userId", null); // Reset existing user field
    this.prevData = data.userDetails.Email;
    this.prevSpid = spe;
  }

  resetFill(val: any){
    this.dataGridPSRView.instance.cellValue(0, "lastName", "");
    this.dataGridPSRView.instance.cellValue(0, "email", "");
    this.dataGridPSRView.instance.cellValue(0, "firstName", "");
    this.dataGridPSRView.instance.cellValue(0, "speId", "");
    this.prevData = null;
    this.prevSpid = val;
  }


  confirmUserNotFound(){
    
    
      this.confirmationPopupOption={
        message:"User Details Not Found",
        rejectButtonText:"OK",
        normalButtonText:"",
        confirmButtonText:"",
        showCloseButtn:false,
        visible:true,
        option:"userdetail"
      };
    }

selectExistingUser(eventData: any, cellInfo: any){
  if(cellInfo.setValue) {
    cellInfo.setValue(eventData.value);
  }
  
  if(eventData.value) {
    // If an existing user is selected
    const getData = this.existingUserList.filter((obj: any) => obj.mpgpsrUserId === eventData.value);
    const newData = getData[0];
    this.existingUsers = newData;

    // Reset searchParam field when existing user is selected
    this.dataGridPSRView.instance.cellValue(0, "searchParam", "");
    
    // Update form with existing user data
    this.updateForm(newData);
  } else {
    // If existing user selection is cleared
    this.existingUsers = [];
    
    // Reset all fields including searchParam
    this.resetFill("");
    
    // Reset form state
    this.autoForm = false;
    this.allowEditing = true;
  }
}

  customGroupValidation(params: any){
    let checkExist = this.manageGrpPsrUsersData.filter((item: any) => item.hasOwnProperty("psrGroupId") && item.psrGroupId === params.data.psrGroupId);
     let speID = checkExist.map((a:any) => a.speId.toLowerCase());
     let emailID = checkExist.map((a:any) => a.email.toLowerCase());
    
    if(this.existingUsers.length != 0){
    if(speID.includes(this.existingUsers.speId.toLowerCase()) || emailID.includes(this.existingUsers.email.toLowerCase())){
          return false;
        }else{
          return true;
        } 
    }else{
      return true
    }
    
  }

  // onEditorPreparing(e: any) {
  
  //   if (e.parentType === "dataRow" && e.dataField !== "mpgpsrUserId") {
  //       return;
  //   }
  //   if (!e.row.isNewRow || e.row.isNewRow == undefined){
  //     e.editorOptions.disabled = true;
  //   }

        
  // }

  
  customAlert(message:any){

    const mpDialog = custom({

      showTitle: false,

      messageHtml: message,

      buttons: [


        {

            text: "Close",

            onClick: () => false

        }

      ]

    });



    mpDialog.show().then((dialogResult:any) => {});

  }


  selectExistUser(eventData: any, cellInfo: any){
    
    if(cellInfo.setValue) {
      cellInfo.setValue(eventData.value);
    }

  }

  onAddPsrUserGrp(newData: any){
    this.isrowEdit = false;
    this.existingUsers = [];
    this.editRow = "";
    this.showSelect = false;
    this.autoForm = false;
    this.allowEditing = true;
    newData.data.groupId="";
    newData.data.firstName="";
    newData.data.lastName="";
    newData.data.speId="";
    newData.data.email="";
  }

  

  updatePsrUsersGrp(e:any){
    console.log(e);
    let key:any;
		let operation:string;
		if(e && e.changes.length){
		  this.showLoadPanel=true;
			key=e.changes[0].key;
			operation=e.changes[0].type;
			if(operation=='remove' && key){
				this.deleteGrpUser(e);
			}
			else{
				this.saveGrpUser(e);
			}
		}
  }

  saveGrpUser(e: any){
    this.saveUpdateGrpData = e.changes[0].data;
    let constructedData;

    if(e.changes[0].type=='insert' && e.changes[0].key){
      constructedData = {
        "psrGroupId": e.changes[0].data.psrGroupId,
        "mpgUserDto": 
            {
                    "mpgpsrUserId": e.changes[0].data.userId,
                    "firstName": e.changes[0].data.firstName,
                    "lastName": e.changes[0].data.lastName,
                    "middleInitial": "",
                    "email": e.changes[0].data.email,
                    "speId": e.changes[0].data.speId
                }

                
    
    }
    }else if(e.changes[0].type=='update' && e.changes[0].key){
constructedData = {
  "psrGroupId": e.changes[0].data.psrGroupId,
  "psrUserDto": 
      {

              "userId": e.changes[0].data.userId,
              "speId": e.changes[0].data.speId,
              "lastName": e.changes[0].data.lastName,
              "firstName": e.changes[0].data.firstName,
              "middleInitial": "",
              "email": e.changes[0].data.email,
              "activeFlag": true,
              "mpgpsrUserRefId":e.changes[0].data.mpgpsrUserRefId 
          }

          

}
    }
    this.grpUsersService.savePSRGrpUser(constructedData).subscribe(
      r=>{
        console.log(r);
        if(r.status=="SUCCESS" && r.serviceResult){
          this.fetchMPGGrpUser();
          this.showLoadPanel=false;
        }
      }
    );
  }

  deleteGrpUser(e:any){

    this.saveUpdateGrpData = e.changes[0].key;
    let constructedData = {
        "psrGroupId": e.changes[0].key.psrGroupId,
        "psrUserDto": 
            {
                    "userId": e.changes[0].key.userId,
                    "speId": e.changes[0].key.speId,
                    "lastName": e.changes[0].key.lastName,
                    "firstName": e.changes[0].key.firstName,
                    "middleInitial": "",
                    "email": e.changes[0].key.email,
                    "activeFlag": true,
                    "mpgpsrUserRefId": e.changes[0].key.mpgpsrUserRefId
                }
    
    };
    
    this.grpUsersService.deletPSRGrpUser(constructedData).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
         // this.manageGrpPsrUsersData = r.serviceResult;
         this.showLoadPanel=false;
        }
    });
  }
  onEditingStart(e: any){
    this.isrowEdit = true;
    this.editRow = e.data;
    this.showSelect = true;
    this.allowEditing = true;
    this.existingUsers = [];
  }

  onEditCanceled(e: any) {
    this.prevSpid = null;
    this.prevData = null;
  }

  

  selectGroupName(eventData: any, cellInfo: any) {
    this.selectedGroup = eventData.value;
    if(cellInfo.setValue) {
      cellInfo.setValue(eventData.value);
    };
    
  }

  

  updateForm(value: any){
    this.dataGridPSRView.instance.cellValue(0, "firstName", value.firstName);
    this.dataGridPSRView.instance.cellValue(0, "lastName", value.lastName);
    this.autoForm = true;
    this.dataGridPSRView.instance.cellValue(0, "speId", value.speId);
    this.dataGridPSRView.instance.cellValue(0, "email", value.email);
    this.allowEditing = false;
  }

}
